import api from "../services";

const getleaveType = api.injectEndpoints({
  endpoints: (builder) => ({
      getLeaveTypes: builder.query({
      query: () => ("/api/leaveCategory/getAllLeaveCategories"),
    }),
    withdrawAppliedLeave: builder.mutation({
      query: ({id, payload}) => ({
        url: `/api/leaveTransaction/leavewithdrawal?leaveTransactionId=${id}`,
        method: "PUT",
        body : payload
      }),
    }),
  }),
});

export default getleaveType;
export const {  useGetLeaveTypesQuery, useWithdrawAppliedLeaveMutation } = getleaveType;